import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { updateSetting, useSession } from '@ltvco/refresh-lib/v1';
import { useQueryClient } from '@ltvco/refresh-lib/vendors';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const ALLOWED_REPORT_TYPES = [
  'person',
  'email',
  'phone',
  'property',
  'vehicle',
  'username',
  'unclaimed-money',
  'contact',
  'phone-fraud',
  'email-fraud',
  'ip-fraud',
  'url-fraud',
];

const isPathAllowed = (pathname: string): boolean => {
  if (pathname === '/dashboard' || pathname.startsWith('/dashboard/')) {
    return true;
  }

  const reportType = pathname.match(/^\/report\/([^/]+)/)?.[1];
  return reportType != null && ALLOWED_REPORT_TYPES.includes(reportType);
};

export const useMobileDownloadSnackbar = () => {
  const { isMobile } = useScreenSize();
  const { pathname } = useLocation();
  const queryClient = useQueryClient();
  const {
    session: { account },
  } = useSession();

  const [isHiding, setIsHiding] = useState(false);

  const isDismissed =
    account?.account?.user_settings?.hide_mobile_download_snackbar === true;

  const shouldShowSnackbar =
    !isHiding &&
    account != null &&
    isMobile &&
    isPathAllowed(pathname) &&
    !isDismissed;

  const hideSnackbar = async () => {
    setIsHiding(true);

    try {
      await updateSetting({
        setting: 'hide_mobile_download_snackbar',
        state: true,
      });
    } catch (error) {
      setIsHiding(false);
      console.error('Failed to update user setting:', error);
      return;
    }

    try {
      await queryClient.invalidateQueries({ queryKey: ['account'] });
    } catch (error) {
      console.error('Failed to invalidate account cache:', error);
    }
  };

  return {
    shouldShowSnackbar,
    hideSnackbar,
  };
};
